import {
  put,
  fork,
  call,
  takeEvery,
  all,
  select,
  takeLatest,
} from 'redux-saga/effects';
import app from '../../app';
import {
  loadShopListCompletion,
  loadStoreCityListCompletion,
  loadAppointListCompletion,
  loadAppointCompletion,
  loadCouponListByChannelCodeCompletion,
  createAppointCompletion,
  loadAppointTimesCompletion,
  cancelAppointCompletion,
  loadAppoint,
  catchError,
} from '../../actions';

export function* watchLoadStoreCityList() {
  yield takeEvery('LOAD_STORE_CITY_LIST', function*() {
    const options = {
      url: `/api/store/city/list`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadStoreCityListCompletion(result.data, result.error));
  });
}

export function* watchLoadCouponListByChannelCode() {
  yield takeEvery('LOAD_COUPON_LIST_BY_CHANNEL_CODE', function*({
    channelCode,
  }) {
    const options = {
      url: `/api/coupons/lijing2?channelCode=${channelCode}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadCouponListByChannelCodeCompletion(result.error, result.data));
  });
}

export function* watchLoadShopList() {
  yield takeEvery('LOAD_SHOP_LIST', function*(action) {
    const options = {
      url: `/api/store/list`,
      method: 'GET',
      data: { ...action.input },
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadShopListCompletion(result.data, result.error));
  });
}

function* watchLoadAppointList() {
  yield takeLatest('LOAD_APPOINT_LIST', function*({ willReload }) {
    const { list, query } = yield select(state => state.mall.appoint.master);
    const tabDict = { all: '', appoint: 0, cancel: 1 };
    let start = 0;
    let tab = '';

    if (!willReload && list) {
      start = list.length;
    }

    tab = tabDict[query.tab];

    const options = {
      url: `/api/reserve/myReserveList`,
      method: 'GET',
      data: {
        reserveStatus: tab,
        start,
        size: query.size,
      },
    };

    const result = yield call(app.httpFetch, options);
    yield put(
      loadAppointListCompletion(
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

function* watchLoadAppoint() {
  yield takeEvery('LOAD_APPOINT', function*({ id }) {
    const options = {
      url: `/api/reserve/myReserve/${id}`,
    };
    let result = yield call(app.httpFetch, options);

    yield put(loadAppointCompletion(id, result.data, result.error));
  });
}

function* watchCreateAppoint() {
  yield takeEvery('CREATE_APPOINT', function*() {
    const { input } = yield select(state => state.mall.appoint.edit);
    const options = {
      url: `/api/reserve/createReserve`,
      method: 'POST',
      data: { ...input },
    };

    let error;
    if (!input.reserveName) {
      error = new Error('预约人不能为空');
    }
    if (!input.reserveMobile) {
      error = new Error('预约人手机号不能为空');
    }

    if (error) {
      yield put(catchError(error));
      yield put(createAppointCompletion(null, error));
      return;
    }

    let result = yield call(app.httpFetch, options);

    yield put(createAppointCompletion(result.data, result.error));
  });
}

function* watchLoadAppointTimes() {
  yield takeEvery('LOAD_APPOINT_TIMES_LIST', function*({ query }) {
    const { currentStore } = yield select(state => state.mall.appoint.stores);
    const options = {
      url: `/api/reserve/getReservePit`,
      data: {
        storeId: currentStore?.storeId,
        ...query,
      },
      method: 'POST',
    };
    let result = yield call(app.httpFetch, options);

    yield put(loadAppointTimesCompletion(result.data, result.error));
  });
}

function* watchCancelAppoint() {
  yield takeEvery('CANCEL_APPOINT', function*({ id }) {
    const options = {
      url: `/api/reserve/cancelReserveOrder`,
      data: {
        reserveCode: id,
      },
      method: 'POST',
    };
    let result = yield call(app.httpFetch, options);

    if (!result.error) {
      yield put(loadAppoint(id));
    }

    yield put(cancelAppointCompletion(id, result.data, result.error));
  });
}

export default function* appointSaga() {
  yield all([
    fork(watchLoadStoreCityList),
    fork(watchLoadShopList),
    fork(watchLoadAppointList),
    fork(watchLoadAppoint),
    fork(watchCreateAppoint),
    fork(watchLoadAppointTimes),
    fork(watchCancelAppoint),
    fork(watchLoadCouponListByChannelCode),
  ]);
}
